import { ROUTES } from '@/router/routesEnum';

export interface QrCode {
  id?: string; // System.Guid
  name: string; // string
  active: boolean;
  type: QrCodeTypeEnum;
  validFrom: string; // System.DateTime
  validTill: string; // System.DateTime
  address: string; // string
  lat: number; // double
  lng: number; // double
  locationId?: string;
  locationName?: string;
  courseId?: string;
  courseName?: string;
  readonly preferredDisplayName: string;
  qrCodeUrl: string;
  checkGps: boolean; // bool
  saveGpsByCheck: boolean; // bool
  securityPhrase: string; // string
  companyId?: string;
  createdDate: string; // System.DateTime
}

export type QrCodeTypeEnum = 0 | 1;
export const QrCodeTypeEnum = {
  SelfCheckin: 0 as QrCodeTypeEnum,
  MembershipApplication: 1 as QrCodeTypeEnum,
};

export interface Value {
  value: QrCode[];
  '@odata.context'?: string | undefined;
  '@odata.count'?: number | undefined;
}

// init api object
function toAPI(data: Partial<QrCode>): any {
  return {
    Id: data?.id || undefined,
    Name: data?.name || '',
    Active: data?.active || false,
    Type: data?.type ?? QrCodeTypeEnum.SelfCheckin,
    ValidFrom: data?.validFrom || '',
    ValidTill: data?.validTill || '',
    Address: data?.address || '',
    Lat: data?.lat || 0,
    Lng: data?.lng || 0,
    LocationId: data?.locationId || undefined,
    CourseId: data?.courseId || undefined,
    QrCodeUrl: data?.qrCodeUrl || '',
    CheckGps: data?.checkGps || false,
    SaveGpsByCheck: data?.saveGpsByCheck || false,
    SecurityPhrase: data?.securityPhrase || '',
    CompanyId: data?.companyId || undefined,
  };
}

function parse(data?: Partial<QrCode>): QrCode {
  const qrCodeType =
      data?.type || getQrCodeTypeText(QrCodeTypeEnum.SelfCheckin);

  return {
    id: data?.id || undefined,
    active: data?.active || false,
    name: data?.name || '',
    type: QrCodeTypeEnum[qrCodeType as keyof typeof QrCodeTypeEnum],
    validFrom: data?.validFrom || new Date().toISOString().substring(0, 10),
    validTill: data?.validTill || new Date().toISOString().substring(0, 10),
    address: data?.address || '',
    lat: data?.lat || 0,
    lng: data?.lng || 0,
    locationId: data?.locationId || undefined,
    locationName: data?.locationName || undefined,
    courseId: data?.courseId || undefined,
    courseName: data?.courseName || undefined,
    get preferredDisplayName() {
      return this.courseName ?? this.locationName ?? this.name;
    },
    qrCodeUrl: data?.qrCodeUrl || '',
    checkGps: data?.checkGps || false,
    saveGpsByCheck: data?.saveGpsByCheck || false,
    securityPhrase: data?.securityPhrase || '',
    companyId: data?.companyId || undefined,
    createdDate: data?.createdDate || new Date().toISOString().substring(0, 10),
  };
}

export function createQrCodePrintUrl(url: string, displayName: string): string {
  let qrCodeUrl = encodeURIComponent(btoa(url));
  let displayNameUrl = encodeURIComponent(btoa(displayName));
  return `/${ROUTES.print_qr_code}/${qrCodeUrl}/${displayNameUrl}`;
}

export default {
  parse,
  toAPI: toAPI,
};

export function getQrCodeTypeText(status: QrCodeTypeEnum) {
  return Object.keys(QrCodeTypeEnum)[
    Object.values(QrCodeTypeEnum).findIndex((entry) => entry == status)
  ];
}